// export const CreateSubscriptionPlanDefaultValues = {
//   name: 'PLANNAME',
//   description: 'Sample plan description',
//   baseCost: 200,
//   // corporatePlan: false,
//   billingPeriod: 'month',
//   planFor: 'VISITOR',
//   isIncremental: 'No',
//   labelName: '',
//   // yearlyDiscount: {
//   //   type: 'MONTH',
//   //   value: 1,
//   // },
//   features: {
//     premise: {
//       // value: 1,
//       // addOn: {
//       //   unitPrice: 25,
//       //   unitQuantity: 2,
//       // },
//       type: 'INCLUDED',
//       limit: 1,
//     },
//     geofence: {
//       type: 'INCLUDED',
//       limit: 0,
//     },
//     user: {
//       // value: 2,
//       // addOn: {
//       //   unitPrice: 25,
//       //   unitQuantity: 2,
//       // },
//       type: 'INCLUDED',
//       // limit: 0,
//     },
//     timesheet: {
//       // type: 'OPTIONAL',
//       // value: 2,
//       // addOn: {
//       //   unitPrice: 25,
//       //   unitQuantity: 2,
//       // },
//       type: 'INCLUDED',
//       // limit: 0,
//     },
//     // emergencyWarning: {
//     //   type: 'INCLUDED',
//     // },
//     logbook: {
//       type: 'INCLUDED',
//     },
//     sos: {
//       type: 'INCLUDED',
//     },
//     // workSafety: {
//     //   type: 'UNAVAILABLE',
//     // },
//     edec: {
//       limit: 0,
//       type: 'INCLUDED',
//       // value: 2,
//       // addOn: {
//       //   unitPrice: 25,
//       //   unitQuantity: 2,
//       // },
//     },
//     // nvd: {
//     //   type: 'UNAVAILABLE',
//     // },
//     desktopAccess: {
//       type: 'INCLUDED',
//     },
//     // gateSignIn: {
//     //   type: 'UNAVAILABLE',
//     // },
//     broadcast: {
//       type: 'INCLUDED',
//     },
//   },
// };

export const modifyPlanName = (planName, suffixName) => {
  let modifiedName = '';

  const lowerCasePlanName = planName?.toLowerCase();

  if (lowerCasePlanName.includes('monthly')) {
    modifiedName = planName?.replace(/Monthly/i, '') + suffixName;
  } else if (lowerCasePlanName.includes('annually')) {
    modifiedName = planName?.replace(/Annually/i, '') + suffixName;
  } else if (lowerCasePlanName.includes('daily')) {
    modifiedName = planName?.replace(/Daily/i, '') + suffixName;
  } else {
    modifiedName = planName + '-' + suffixName;
  }
  return modifiedName?.toUpperCase();
};

export const ArrayOfQuantity = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
];

export const addOnDefaultValues = {
  baseCost: 200,
  billingPeriod: 'month',
};

export const EdecArrayOfQuantity = [];

for (let i = 1; i <= 120; i++) {
  EdecArrayOfQuantity.push({ label: i.toString(), value: i.toString() });
}

export const CreateSubscriptionPlanDefaultValues = {
  description: 'Sample plan description',
  baseCost: 200,
  billingPeriod: 'month',
  isIncremental: 0,
  labelName: '',
  features: {
    premise: {
      type: 'INCLUDED',
      limit: 1,
      range: 15,
    },
    geofence: {
      type: 'INCLUDED',
      limit: 1,
    },
    user: {
      type: 'INCLUDED',
    },
    timesheet: {
      type: 'INCLUDED',
    },
    logbook: {
      type: 'INCLUDED',
    },
    sos: {
      type: 'INCLUDED',
    },
    edec: {
      limit: 0,
      type: 'INCLUDED',
    },
    desktopAccess: {
      type: 'INCLUDED',
    },
    broadcast: {
      type: 'INCLUDED',
    },
  },
};

// helper function to billing period label

export const getBillingPeriodLabel = (value) => {
  const options = {
    month: 'Monthly',
    year: 'Annually',
    day: 'Daily',
  };
  return options[value] || value;
};
